import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { UserProfileService } from 'src/app/services/user-profile/user-profile.service';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    YocoSDK: any;
  }
}

@Component({
  selector: 'app-user-deposit',
  templateUrl: './user-deposit.page.html',
  styleUrls: ['./user-deposit.page.scss'],
})
export class UserDepositPage implements OnInit {
  userID;
  sdk;
  inline;
  isBtnClicked = false;
  status = false;
  showPay = false;

  rands;

  ownAmount = false;
  showValueStep = true;
  showPayStep = false;

  userProfile;
  userRef;

  private yocoPK = environment.yokoPK;
  private url = environment.webUrl;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private firestore: AngularFirestore,
    private httpClient: HttpClient,
    private userProfileService: UserProfileService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.userID = params.userID;
      this.userProfileService
        .getProfile(this.userID)
        .pipe(take(1))
        .subscribe((profRes) => {
          if (profRes.exists) {
            this.userProfile = profRes.data();
            this.userProfileService
              .getUserRefNo(this.userID)
              .pipe(take(1))
              .subscribe((refRes) => {
                if (refRes.exists) {
                  this.userRef = refRes.data();
                } else {
                  const name = this.userProfile.name.toUpperCase();
                  const prefix = name[0] + name[name.length - 1];
                  this.userProfileService
                    .createUserRefNo(this.userID, prefix)
                    .then(() => {
                      this.router.navigate(['/user-wallet']);
                    });
                }
              });
          } else {
            this.router.navigate(['/home/login'], {
              queryParams: { from: this.router.url },
            });
          }
        });
    });
    // this.initPay();
  }

  initPay() {
    this.sdk = new window.YocoSDK({
      publicKey: this.yocoPK,
    });

    this.inline = this.sdk.inline({
      layout: 'basic',
      amountInCents: this.rands * 100,
      currency: 'ZAR',
    });
    this.inline.mount('#card-frame');

    this.inline.on('ready', (event) => {
      // console.log('ready => ' + event);
    });

    this.inline.on('change', (event) => {
      console.log('change = ' + event);
    });

    this.inline.on('validity_change', (event) => {
      // console.log('v change => ' + event.isValid());
      if (event.isValid()) {
        this.status = true;
      }
    });
  }

  pay() {
    this.isBtnClicked = true;
    this.inline
      .createToken()
      .then((result) => {
        if (result.error) {
          this.isBtnClicked = false;
          const errorMessage = result.error.message;
          alert(errorMessage);
        } else {
          const token = result.id;
          const obj = {
            token,
            amountInRands: this.rands,
            orderNo: this.userID,
          };
          return this.httpClient
            .post(this.url + '/charge.php', JSON.stringify(obj))
            .pipe(take(1))
            .subscribe((response: any) => {
              this.isBtnClicked = false;
              // console.log(response);
              if (response.status) {
                this.userProfileService
                  .uploadWallet(this.userID, this.rands)
                  .then(() => {
                    alert('payment made');
                    this.router.navigate(['/user-wallet']).then(() => {
                      window.location.reload();
                    });
                  });
              } else if (response.errorCode) {
                this.isBtnClicked = false;
                alert(response.displayMessage);
              }
            });
        }
      })
      .catch((error) => {
        this.isBtnClicked = false;
        alert('error occured: ' + JSON.stringify(error));
      });
  }

  valueChange(e) {
    const value = e.detail.value;
    if (value.toLowerCase() === 'own-amount') {
      this.ownAmount = true;
      this.rands = '';
    } else {
      this.ownAmount = false;
      this.rands = value;
    }
  }

  continueToPay() {
    // if (this.rands !== '' && this.rands !== undefined && this.rands !== null) {
    if (this.rands) {
      this.showValueStep = false;
      this.showPayStep = true;
      this.initPay();
    } else {
      alert('Invalid value');
    }
  }

  toTopUpValue() {
    this.showValueStep = true;
    this.showPayStep = false;
  }

  deposit() {
    this.router.navigate(['user-wallet']);
  }
}
